// Preserve existing Gravity Forms stylesheet if already loaded during Barba transitions
export function preserveGravityFormsStylesheet(next) {
  const newHeadLinks = next.html
    .match(/<link .*?>/g)
    ?.filter((link) => link.includes("gravityforms"));

  if (newHeadLinks) {
    newHeadLinks.forEach((link) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(link, "text/html");
      const newLink = doc.querySelector("link");
      const href = newLink?.getAttribute("href");

      if (href && !document.querySelector(`link[href="${href}"]`)) {
        document.head.appendChild(newLink);
      }
    });
  }
}

export function reinitGravityForms(nextContainer) {
  if (!nextContainer) return;

  const wrappers = nextContainer.querySelectorAll(".gform_wrapper");
  if (!wrappers.length) return;

  const initForms = () => {
    wrappers.forEach((wrapper) => {
      const wrapperId = wrapper.getAttribute("id") || "";
      const match = wrapperId.match(/gform_wrapper_(\d+)/);
      const formId =
        match?.[1] ||
        wrapper
          .querySelector('form[id^="gform_"]')
          ?.getAttribute("id")
          ?.replace("gform_", "");

      if (!formId) return;

      const currentPageInput = wrapper.querySelector(
        `#gform_source_page_number_${formId}`,
      );
      const currentPage = currentPageInput
        ? parseInt(currentPageInput.value, 10) || 1
        : 1;

      if (window.gform?.core?.triggerPostRenderEvents) {
        window.gform.core.triggerPostRenderEvents(Number(formId), currentPage);
        return;
      }

      const jq = window.jQuery || window.$;
      if (jq) {
        jq(document).trigger("gform_post_render", [
          Number(formId),
          currentPage,
        ]);
      }
    });
  };

  if (window.gform && typeof window.gform.initializeOnLoaded === "function") {
    window.gform.initializeOnLoaded(initForms);
  } else {
    initForms();
  }
}
